import { gql } from '@apollo/client'
import { head } from 'ramda'
import React from 'react'

import { generalClient } from '../../../../../utils/apollo/api'
import StatePresenter from '../../../../../packages/kiti/components/helpers/StatePresenter'
import { usePaginatedQuery } from '../../../../../utils/apollo/_helpers/pagination'
import PaginationControl from '../../../../../components/helpers/PaginationControl'

const NAME = 'service_order_sla'

const Context = React.createContext([])
const { Provider } = Context
export const useConfigState = () => React.useContext(Context)
export const useConfig = () => useConfigState()?.config

const QUERY = gql`
  query Configs($name: String, $page: Int, $limit: Int) {
    configs(filter: { name: $name }, page: $page, limit: $limit) {
      id
      name
      value
      enabled
      updatedAt
      insertedAt
    }
  }
`

const ConfigsLoader = ({ children }) => {
  const [page, setPage] = React.useState(1)
  const { data, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: { name: NAME, page: page, limit: 5 },
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <Provider
      value={{
        ...data,
        config: data?.configs || [],
        fetchMore,
        variables: state.variables,
        loading: state.loading,
        page: page
      }}
    >
      <StatePresenter {...state} empty={false}>
        {children}
      </StatePresenter>
      <PaginationControl fetchMore={fetchMore} page={page} onChange={setPage} state={state} isNumbered />
    </Provider>
  )
}

export default ConfigsLoader
